export default __webpack_public_path__ + "static/media/file_checkmark.f5748432.svg";